import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { ErrorsService } from './core/services/errors/errors.service';
import { GlobalLoaderService } from '@core/services/global-loader.service';
import { AuthService } from '@auth0/auth0-angular';
import { filter, firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  public title = 'cs-platform';
  public constructor(
    public errorService: ErrorsService,
    public globalLoaderService: GlobalLoaderService,
    private auth: AuthService,
    private router: Router,
  ){}
  
  async ngOnInit() {
    // Scroll to top on every route change
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        window.scrollTo({ top: 0, left: 0 });
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      });

    // A guard returning false / a rejected guard-or-resolver promise aborts a
    // navigation with NO user-visible feedback (a click that "does nothing").
    // Outside production, surface every aborted navigation with its reason so
    // those reports are diagnosable from the console (BF-48).
    if (!environment.production) {
      this.router.events
        .pipe(filter((e) => e instanceof NavigationCancel || e instanceof NavigationError))
        .subscribe((e) => {
          if (e instanceof NavigationCancel) {
            console.warn(`[router] navigation to "${e.url}" cancelled (code ${e.code}): ${e.reason}`);
          } else if (e instanceof NavigationError) {
            console.warn(`[router] navigation to "${e.url}" errored:`, e.error);
          }
        });
    }

    // Handle the redirect and retrieve custom data from appState$
    const auth0State = await firstValueFrom(this.auth.appState$)
    // Redirect to the intended page with query parameters
    if (auth0State.redirect) {
      window.location.href = auth0State.redirect;
    }
  }
}
